export var priceFormatter = function priceFormatter(currency, amount) {
  var shouldConvertToDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2
  })
  // Move decimal two places to the left.
  .format(shouldConvertToDecimal ? amount / 100 : amount)
  // Stripping out double zeros after the decimal place
  .replace(/\D00(?=\D*$)/, '')
  // Remove any alphabetical characters
  .replace(/[a-z]/gi, '');
};